import classNames from "classnames";
import { FiltersList } from "@circle-react-shared/Filter/FiltersList";
import { NameFilter } from "./NameFilter";
import { SpaceGroupFilter } from "./SpaceGroupFilter";
import { TypeFilter } from "./TypeFilter";

export interface FiltersBarProps {
  isModal?: boolean;
  name: string;
  onNameChange: (v: string) => void;
  onSpaceGroupChange?: (v: string) => void;
  onTypeChange: (v: string) => void;
  showSpaceGroup?: boolean;
  spaceGroup?: string;
  type: string;
  typeOptions: { label: string; value: string }[];
}

export const FiltersBar = ({
  name,
  onNameChange,
  type,
  onTypeChange,
  typeOptions,
  spaceGroup,
  onSpaceGroupChange,
  showSpaceGroup = false,
  isModal = false,
}: FiltersBarProps) => (
  <div
    className={classNames(
      "bg-primary border-primary flex items-center justify-between gap-x-1 border-b py-3",
      isModal ? "px-5" : "px-6 lg:px-9",
    )}
  >
    <FiltersList>
      <NameFilter value={name} onChange={onNameChange} />
      <TypeFilter value={type} onChange={onTypeChange} options={typeOptions} />
      {showSpaceGroup && onSpaceGroupChange && (
        <SpaceGroupFilter
          value={spaceGroup || ""}
          onChange={onSpaceGroupChange}
        />
      )}
    </FiltersList>
  </div>
);
